import { Directive, HostListener, Input, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class NgxUpperCaseDirective {
    /**
     * @param {?} el
     * @return {?}
     */
    getCaret(el) {
        return {
            start: el.selectionStart,
            end: el.selectionEnd,
        };
    }
    /**
     * @param {?} el
     * @param {?} start
     * @param {?} end
     * @return {?}
     */
    setCaret(el, start, end) {
        el.selectionStart = start;
        el.selectionEnd = end;
        el.focus();
    }
    /**
     * @param {?} el
     * @param {?} eventType
     * @return {?}
     */
    dispatchEvent(el, eventType) {
        const /** @type {?} */ event = document.createEvent('Event');
        event.initEvent(eventType, false, false);
        el.dispatchEvent(event);
    }
    /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    convertValue(el, value) {
        el.value = value.toUpperCase();
        this.dispatchEvent(el, 'input');
    }
    /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    onBlur(el, value) {
        if ((!this.upperCase || 'blur' === this.upperCase) && 'function' === typeof value.toUpperCase && value.toUpperCase() !== value) {
            this.convertValue(el, value);
            this.dispatchEvent(el, 'blur'); // in case updateOn is set to blur
        }
    }
    /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    onInput(el, value) {
        if (!this.upperCase && 'function' === typeof value.toUpperCase && value.toUpperCase() !== value) {
            let { start, end } = this.getCaret(el);
            if (value[0] === ' ' && start === 1 && end === 1) {
                start = 0;
                end = 0;
            }
            this.convertValue(el, value);
            this.setCaret(el, start, end);
        }
    }
}
NgxUpperCaseDirective.ɵfac = function NgxUpperCaseDirective_Factory(t) { return new (t || NgxUpperCaseDirective)(); };
NgxUpperCaseDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxUpperCaseDirective, selectors: [["input", "upperCase", "", 3, "lowerCase", ""], ["textarea", "upperCase", "", 3, "lowerCase", ""]], hostBindings: function NgxUpperCaseDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function NgxUpperCaseDirective_blur_HostBindingHandler($event) { return ctx.onBlur($event.target, $event.target.value); })("input", function NgxUpperCaseDirective_input_HostBindingHandler($event) { return ctx.onInput($event.target, $event.target.value); });
    } }, inputs: { upperCase: "upperCase" } });
/** @nocollapse */
NgxUpperCaseDirective.propDecorators = {
    "upperCase": [{ type: Input },],
    "onBlur": [{ type: HostListener, args: ['blur', ['$event.target', '$event.target.value'],] },],
    "onInput": [{ type: HostListener, args: ['input', ['$event.target', '$event.target.value'],] },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxUpperCaseDirective, [{
        type: Directive,
        args: [{
                selector: 'input[upperCase]:not([lowerCase]),textarea[upperCase]:not([lowerCase])'
            }]
    }], null, { 
    /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    onBlur: [{
            type: HostListener,
            args: ['blur', ['$event.target', '$event.target.value']]
        }], 
    /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    onInput: [{
            type: HostListener,
            args: ['input', ['$event.target', '$event.target.value']]
        }], upperCase: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxUpperCaseDirectiveModule {
}
NgxUpperCaseDirectiveModule.ɵfac = function NgxUpperCaseDirectiveModule_Factory(t) { return new (t || NgxUpperCaseDirectiveModule)(); };
NgxUpperCaseDirectiveModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxUpperCaseDirectiveModule });
NgxUpperCaseDirectiveModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxUpperCaseDirectiveModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [NgxUpperCaseDirective],
                exports: [NgxUpperCaseDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxUpperCaseDirectiveModule, { declarations: [NgxUpperCaseDirective], exports: [NgxUpperCaseDirective] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { NgxUpperCaseDirective, NgxUpperCaseDirectiveModule };

